import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useDeleteEmailAddressMutation } from "@/redux/services/sendersApi"
import { setToast } from "@/redux/toastSlice"

export const useDeleteEmailAddress = () => {
  const dispatch = useAppDispatch()
  const [deleteEmailAddress, response] = useDeleteEmailAddressMutation()

  const handleDeleteEmailAddress = async ({ id }: { id: string }) => {
    try {
      const response = await deleteEmailAddress({ id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success delete email address",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { deleteEmailAddress: handleDeleteEmailAddress, response }
}
